import React from "react";
import { createRoot } from "react-dom/client";
import dayjs from "dayjs";
import LocalizedFormat from "dayjs/plugin/localizedFormat";
import Calender from "dayjs/plugin/calendar";
import duration from "dayjs/plugin/duration";
import utc from "dayjs/plugin/utc";
import timezone from "dayjs/plugin/timezone";

// 다국어 로케일 가져오기
import 'dayjs/locale/ko';
import 'dayjs/locale/ja';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/th';
import 'dayjs/locale/en';

import App from "./App";
import * as serviceWorker from "./serviceWorker";
import "antd/dist/reset.css";
import { THEME_CONFIG } from "configs/AppConfig";

// Extend dayjs with the LocalizedFormat plugin
dayjs.extend(LocalizedFormat);
dayjs.extend(Calender);
dayjs.extend(duration);
dayjs.extend(utc);
dayjs.extend(timezone);

// 기본 로케일 설정
const setDayjsLocale = () => {
  const currentLang = THEME_CONFIG.locale || 'en';
  switch(currentLang) {
    case 'ko':
      dayjs.locale('ko');
      break;
    case 'ja':
      dayjs.locale('ja');
      break;
    case 'zh-Hans':
      dayjs.locale('zh-cn');
      break;
    case 'th':
      dayjs.locale('th');
      break;
    default:
      dayjs.locale('en');
      break;
  }
};

// 초기 로케일 설정
setDayjsLocale();

const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript

window.addEventListener("error", function (event) {
  if (/Loading chunk [\d]+ failed/.test(event.message)) {
    window.location.reload();
  }
});

root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
